import { createLogger } from '@genesislcap/foundation-logger';
export const logger = createLogger('foundation-shell');
